import cn from "classnames";
import { idlenessStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { enumLabel } from "helpers/system";
import { divIcon } from "leaflet";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Marker, Popup, Tooltip } from "react-leaflet";
import { getCarLastBidInfo } from "sources/books/trucks";

const MarkerWrap = ({ item, history, enums, withActions = false, organization }) => {
    const marker = (item.lastCarLocation ? item.lastCarLocation : item) || {};
    const [data, setData] = useState({});
    const [loaded, setLoaded] = useState(false);
    const tooltipRef = useRef();
    const markerRef = useRef();
    const { location, car, status, fixedAt } = marker;
    const { driver, trailer, bidId } = data || {};
    const [longitude, latitude] = location?.coordinates || [];

    useEffect(() => {
        if (!withActions) {
            markerRef.current?.openPopup();
        }
    }, []);

    const syncTextColor = useMemo(() => {
        if (!fixedAt) {
            return "";
        }
        const momentTime = moment(fixedAt);
        if (momentTime > moment().subtract(30, "m")) {
            return "text-success";
        }
        if (momentTime > moment().subtract(2, "h")) {
            return "text-brand";
        }
        return "text-danger";
    }, [fixedAt]);

    if (!marker || !marker.location || !marker.location.coordinates || !marker.car) {
        return null;
    }

    const className = cn("map__icon map-icon map-icon--blue-track map-icon--car", {
        "map-icon--car--green": status === idlenessStatusesEnum.Idle,
        "map-icon--car--red": status === idlenessStatusesEnum.Busy,
    });

    const eventHandlers = {
        popupopen() {
            tooltipRef.current?.setOpacity(0);
            if (!loaded) {
                getCarLastBidInfo(car.id).then((data) => {
                    setLoaded(true);
                    setData(data);
                });
            }
        },
        popupclose() {
            tooltipRef.current?.setOpacity(0.9);
        },
    };
    const options = {
        position: [latitude, longitude],
        icon: divIcon({ iconSize: [28, 82], className }),
        eventHandlers,
    };

    const popupProps = {
        className: cn("map__popup", { "map__popup--dark": !withActions }),
        closeOnClick: false,
        closeButton: false,
        autoPan: false,
    };
    const fixTime = moment(fixedAt).format("DD.MM.YY H:mm");

    const newBidAction = () => {
        history.push(`${paths.bidNew}?carId=${car.id}`);
    };
    const showBidAction = () => {
        history.push(`${paths.bidShow("bid", bidId)}`);
    };
    const filterByCarAction = () => {
        history.push(`${paths.bid}?carId=${car.id}`);
    };

    return (
        <Marker ref={markerRef} {...options}>
            <Popup {...popupProps}>
                <div
                    className={cn("map__popup-wrapper", {
                        "border-bottom-0": !withActions,
                        "loading loading--small": !loaded,
                    })}
                >
                    <div className="map-car__title">{car.number}</div>
                    {(driver || trailer) && (
                        <div className="map-car__data">
                            {!!driver && (
                                <div>
                                    <div className="d-inline-block">
                                        <strong className="pr-1">Водитель:</strong>
                                    </div>
                                    <div className="d-inline-block">
                                        {driver.shortName}
                                        {driver.phoneNumber && (
                                            <span className="map-car__secondary pl-1">({driver.phoneNumber})</span>
                                        )}
                                    </div>
                                </div>
                            )}
                            {!!trailer && (
                                <div>
                                    <strong className="pr-1">Прицеп:</strong>
                                    <span className="text-nowrap">
                                        {trailer.number}
                                        {trailer.typeId && (
                                            <span className="map-car__secondary pl-1">
                                                ({enumLabel(enums.trailerType, trailer.typeId)})
                                            </span>
                                        )}
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                    <div className={`map-car__secondary font-italic ${syncTextColor}`}>
                        Синхронизация GPS: {fixTime}
                    </div>
                </div>
                {withActions && (
                    <ul className="no-bullet">
                        {!organization.distributedBidRequired && (
                            <li className="c-dropd__list-item" onClick={newBidAction}>
                                Создать заявку для машины
                            </li>
                        )}
                        {bidId && (
                            <li className="c-dropd__list-item" onClick={showBidAction}>
                                Открыть текущую заявку
                            </li>
                        )}
                        <li className="c-dropd__list-item" onClick={filterByCarAction}>
                            Открыть список заявок по машине
                        </li>
                    </ul>
                )}
            </Popup>
            <Tooltip permanent className="map__tooltip" direction="top" ref={tooltipRef}>
                <div>{car.number}</div>
            </Tooltip>
        </Marker>
    );
};

export default MarkerWrap;
